import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

function useCardListHeaderHook({
    initialStage = null,
    scrollRef = null
}) {
    const { stages, stages_to_update } = useSelector(state => state.stage);
    const [currentStage, setCurrentStage] = useState(null);
    const stickyRef = useRef(null)
    const loadedRef = useRef(false);

    const setStageTimeoutRef = useRef(null);

        useEffect(() => {
            const DELAY_MS = 50;
            const getScrollTop = () => {
                if (scrollRef && scrollRef.current) {
                    return scrollRef.current.scrollTop;
                }
                return window.pageYOffset || document.documentElement.scrollTop || 0;
            };
            const handleScroll = () => {
                // If scrolled to the very top, clear any pending timeout and set currentStage to null
                const scrollTop = getScrollTop();
                if (scrollTop === 0 || scrollTop <= 40) {
                    if (setStageTimeoutRef.current) {
                        clearTimeout(setStageTimeoutRef.current);
                        setStageTimeoutRef.current = null;
                    }
                    if (currentStage !== null) {
                        setCurrentStage(null);
                    }
                    return;
                }

                const sections = document.querySelectorAll('[data-stage]');
                const stickyHeight = stickyRef.current ? stickyRef.current.offsetHeight : 0;
                const stickyTop = stickyRef.current ? stickyRef.current.getBoundingClientRect().top : 0;
                let found = null;
                for (let section of sections) {
                    const rect = section.getBoundingClientRect();

                    if (rect.top <= stickyHeight / 2 + stickyTop  && rect.bottom > stickyHeight / 2 + stickyTop) {
                        const stage = JSON.parse(section.getAttribute('data-stage'));

                        if (stage?.id !== currentStage?.id) {
                            found = stage;
                            if (setStageTimeoutRef.current) {
                                clearTimeout(setStageTimeoutRef.current);
                            }
                            setStageTimeoutRef.current = setTimeout(() => {
                                setCurrentStage(stage);
                                setStageTimeoutRef.current = null;
                            }, DELAY_MS);
                        }
                        return;
                    }
                }

                // If no matching section, clear any pending stage change
                if (setStageTimeoutRef.current) {
                    clearTimeout(setStageTimeoutRef.current);
                    setStageTimeoutRef.current = null;
                }
            };
            const target = (scrollRef && scrollRef.current) ? scrollRef.current : window;
            target.addEventListener('scroll', handleScroll);
            // invoke once to set initial state (with delay)
            handleScroll();
            return () => {
                target.removeEventListener('scroll', handleScroll);
                if (setStageTimeoutRef.current) {
                    clearTimeout(setStageTimeoutRef.current);
                    setStageTimeoutRef.current = null;
                }
            };
        }, [currentStage, scrollRef]);

        useEffect(() => {
            if(stages_to_update?.length > 0 && currentStage) {
                let isUpdated = stages_to_update.find(s => s.id === currentStage?.id);

                if(isUpdated) {
                    setCurrentStage(isUpdated);
                }
            }
        }, [stages_to_update]);

        {/* Stage when deleted */}

    return {
        // State
        currentStage,

        // Refs
        stickyRef
    }
}

export { useCardListHeaderHook }